import React, { Component } from 'react';
import './SchoolButtons.css';

import Button from '../Button/Button';

class SchoolButtons extends Component {
  render() {
    return (
      <div className="schoolButtonsContainer">
        <Button direc="left" name="St. Olaf" />
        <Button direc="right" name="Carleton" />
      </div>
    )
  }
}

export default SchoolButtons;



// WEBPACK FOOTER //
// ./src/components/SchoolButtons/SchoolButtons.js